<template>
  <modal-template
    ref="modal"
    size="lg"
    :title="modalTitle"
    :type-modal="MODAL_TYPE"
  >
    <div class="modal-content__main">
      <product-form v-if="product" ref="productForm" :typeSample="typeSample"/>
    </div>

    <div slot="actions" class="modal-content__control" >
      <loader v-if="loading" :fullPage="false" class="mr-4"/>
      <d-button
        type="button"
        :disabled="loading"
        @click="save()"
        class="btn btn-sm btn-primary"
      >
        Salvar
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ModalTemplate from '_shared/Modal.vue';
import MixinFormatMessage from '_common/mixins/FormatMessage';
import ProductForm from '_modules/product/components/ProductForm.vue';
import { _SAVE_PRODUCT_SUCCESS_ } from '_modules/product/components/ProductModel';
import formatErrors from '_common/mixins/FormatErrors';
import { MODAL_TYPE, MODEL, _LOAD_MODEL_MODAL_, _OPEN_MODAL_, _RELOAD_SAMPLE_AGENT_ } from '../SampleModel';

export default {
  name: 'edit-agent-modal',
  data() {
    return {
      MODAL_TYPE,
      typeSample: null,
      loading: false,
      index: null,
    };
  },
  mixins: [MixinFormatMessage, formatErrors],
  components: {
    ModalTemplate,
    ProductForm,
  },
  computed: {
    product() {
      const { product } = this.$store.state.product;
      if (product) {
        Events.$emit(_LOAD_MODEL_MODAL_, product);
        return product;
      }
      return MODEL;
    },
    modalTitle() {
      return this.product?.id ? 'Editar Agente' : 'Novo Agente';
    },
  },
  methods: {
    ...mapActions([
      'getProduct',
      'setToggle',
    ]),
    getProductModel(productId) {
      this.getProduct(productId);
    },
    save() {
      this.$refs.productForm.save();
    },
    handleFormSaved(updatedProduct) {
      Events.$emit(_RELOAD_SAMPLE_AGENT_, {
        ...updatedProduct,
        resultIndex: this.index,
      });
      this.closeModal();
    },
    closeModal() {
      this.loading = false;
      this.setToggle({ type: MODAL_TYPE, bool: false });
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, async ({
      agentId, typeSample, index, type,
    }) => {
      if (type === MODAL_TYPE) {
        this.index = index;
        this.typeSample = typeSample;
        this.getProductModel(agentId);
      }
    });
    Events.$on(_SAVE_PRODUCT_SUCCESS_, this.handleFormSaved);
  },
  beforeDestroy() {
    Events.$off(_OPEN_MODAL_);
    Events.$off(_SAVE_PRODUCT_SUCCESS_, this.handleFormSaved);
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}
</style>
